document.addEventListener("DOMContentLoaded", (event) => {
class ProductSlideshow extends HTMLElement {
    constructor() {
      super();
      this.sliderRef = this.querySelector("[data-slider]");
      this.sliderThumb = this.querySelector("[data-thumbnail]");
      this.galleryThumbs = null;
      this.galleryTop = null;
      this.handleResize = this.handleResize.bind(this);
      this.initSlider = this.initSlider.bind(this);
      this.slidesPerView = this.sliderRef.dataset.sliderperview || 4;
    }
  
    connectedCallback() {
      this.initSlider();
      window.addEventListener("resize", this.handleResize);
    }
  
    initSlider() {
      // Save the active slide index before destroying the sliders
      const activeIndex = this.galleryTop ? this.galleryTop.activeIndex : 0;
  
      // Destroy existing Swipers if they exist
      if (this.galleryThumbs) {
        this.galleryThumbs.destroy(true, true);
        this.galleryThumbs = null;
      }
      if (this.galleryTop) {
        this.galleryTop.destroy(true, true);
        this.galleryTop = null;
      }
  
      const slidesPerViewValue = window.innerWidth >= 749 ? this.slidesPerView : "auto";
      // Initialize the thumbnail slider
      this.galleryThumbs = new Swiper(this.sliderThumb, {
        direction: "horizontal",
        spaceBetween: 0,
        slidesPerView: slidesPerViewValue,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        freeMode: false,
        breakpoints: {
          749: {
            direction: "vertical",
            spaceBetween: 0,
            slidesPerView: this.slidesPerView,
          },
        },
      });
  
      // Initialize the main slider
      this.galleryTop = new Swiper(this.sliderRef, {
        direction: "horizontal",
        spaceBetween: 0,
        effect: "fade",
        thumbs: {
          swiper: this.galleryThumbs,
        },
        a11y: {
          prevSlideMessage: "Previous slide",
          nextSlideMessage: "Next slide",
        },
      });
  
      // Restore the active slide index after initialization
      this.galleryTop.slideTo(activeIndex, 0); // Jump to the previously active slide without animation
  
      // Sync active thumbnail on slide change
      this.galleryTop.on("slideChangeTransitionStart", () => {
        this.updateActiveThumbnail();
      });
  
      // Handle thumbnail clicks
      this.galleryThumbs.on("click", (swiper) => {
        const clickedIndex = swiper.clickedIndex;
        if (clickedIndex !== undefined) {
          this.galleryTop.slideTo(clickedIndex);
        }
      });
    }
  
    updateActiveThumbnail() {
      const activeIndex = this.galleryTop.activeIndex;
  
      // Ensure the active thumbnail is centered in view
      if (this.galleryThumbs) {
        this.galleryThumbs.slideTo(activeIndex, 300); // Smooth transition
      }
    }
  
    handleResize() {
      this.initSlider();
    }
  
    disconnectedCallback() {
      if (this.galleryThumbs) {
        this.galleryThumbs.destroy(true, true);
      }
      if (this.galleryTop) {
        this.galleryTop.destroy(true, true);
      }
      window.removeEventListener("resize", this.handleResize);
    }
  }
  
customElements.define("product-slideshow", ProductSlideshow);
});